/* tslint:disable */
import {
  Notification
} from '../index';

declare var Object: any;
export interface NotificationChainInterface {
  "title": string;
  "creatorId": string;
  "notificationsOrder"?: any;
  "id"?: any;
  "created"?: Date;
  notifications?: Notification[];
}

export class NotificationChain implements NotificationChainInterface {
  "title": string;
  "creatorId": string;
  "notificationsOrder": any;
  "id": any;
  "created": Date;
  notifications: Notification[];
  constructor(data?: NotificationChainInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `NotificationChain`.
   */
  public static getModelName() {
    return "NotificationChain";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of NotificationChain for dynamic purposes.
  **/
  public static factory(data: NotificationChainInterface): NotificationChain{
    return new NotificationChain(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'NotificationChain',
      plural: 'NotificationChains',
      path: 'NotificationChains',
      idName: 'id',
      properties: {
        "title": {
          name: 'title',
          type: 'string'
        },
        "creatorId": {
          name: 'creatorId',
          type: 'string'
        },
        "notificationsOrder": {
          name: 'notificationsOrder',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        notifications: {
          name: 'notifications',
          type: 'Notification[]',
          model: 'Notification',
          relationType: 'hasMany',
          modelThrough: 'ChainNotificationMapping',
          keyThrough: 'notificationId',
          keyFrom: 'id',
          keyTo: 'chainId'
        },
      }
    }
  }
}
